import * as types from "./actiontype";
import * as appActions from "../../../actions/appactions";
import * as appUtilityFunction from "../../../infrastructure/apputilityfunctions";
import sharedGlobals from "../../../sharedglobals";
import workFlowService from "../services/workflowservice";

export const showWorkFlow = (status) => {
  return {
    type: types.SHOW_WORKFLOW,
    payload: status,
  };
};

export function closeReport() {
  return {
    type: types.CLOSE_REPORT,
  };
}

export const getNotificationsEnd = (data) => {
  return {
    type: types.GET_NOTIFICATIONS_END,
    payload: data,
  };
};
export const getApprovalDetailsEnd = (data, processSessionId) => {
  return {
    type: types.GET_APPROVAL_DETAILS_END,
    payload: { data, processSessionId },
  };
};

export const handleInputChange = ({ name, value }) => {
  return {
    type: types.HANDLE_INPUT_CHANGES,
    payload: { name, value },
  };
};
export const excecuteProccessActionEnd = () => {
  return {
    type: types.EXCECUTE_PROCCESS_ACTION_END
  }
}

export function initiateProcess(action) {
  return async function (dispatch, state) {
    //  let currentState = getState(state());
    let input = {
      ActionMenuId: 12,
      SessionId: 131,
      SessionParentId: null,
    };
    try {
     dispatch(appActions.setLoading(true));
      var resp = await workFlowService.initiateProcess(input);
      if (resp.hasErrors) {
        return Promise.resolve(false);
      }
      if (!resp.isSuccess) {
        dispatch(getApprovalDetails(resp.processSessionId));
        dispatch(showWorkFlow(true));
      }
      return true;
    } catch (e) {
      dispatch(appActions.handleError(e));
      return false;
    } finally {
      dispatch(appActions.setLoading(false));
    }
  };
}

export function excecuteProccessAction(action) {
  return async function (dispatch, state) {
    let currentState = getState(state());
    let input = {
      ProcessSessionId: currentState.processSessionId,
      Action: action,
      Remarks: currentState.remarks,
    };
    try {
   dispatch(appActions.setLoading(true));
      var resp = await workFlowService.executeProcessAction(input);
      if (resp.hasErrors) {
        return Promise.resolve(false);
      }
      dispatch(excecuteProccessActionEnd())
      return true;
    } catch (e) {
      dispatch(appActions.handleError(e));
      return false;
    } finally {
      dispatch(appActions.setLoading(false));
    }
  };
}

export function getNotifications() {
  return async function (dispatch, state) {
    try {
      var resp = await workFlowService.getNotifications();
      if (resp.hasErrors) {
        return Promise.resolve(false);
      }
      dispatch(getNotificationsEnd(resp));
      return resp;
    } catch (e) {
      dispatch(appActions.handleError(e));
      return false;
    } finally {
    }
  };
}

export function getApprovalDetails(processSessionId) {
  return async function (dispatch, state) {
    try {
     dispatch(appActions.setLoading(true));
      var resp = await workFlowService.getApprovalDetails(processSessionId);
      if (resp.hasErrors) {
        return Promise.resolve(false);
      }
      dispatch(getApprovalDetailsEnd(resp, processSessionId));
      return resp;
    } catch (e) {
      dispatch(appActions.handleError(e));
      return false;
    } finally {
      dispatch(appActions.setLoading(false));
    }
  };
}

const getState = (state) => {
  return state.workFlowReducer;
};
